import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import AutocompleteField from 'elements/AutocompleteField';
import { ApiRequest } from 'GlobalFunctions';
import LoadingButton from '@mui/lab/LoadingButton'; // Import LoadingButton

interface Props {
  open: boolean;
  onClose: () => void;
  loadList: () => void;
}

export default function NewMessageDialog({ open, onClose, loadList }: Props) {
  const [formValues, setFormValues] = useState<any>({ nurses: [], message_text: '' });
  const [loading, setLoading] = useState(false); // State for loading

  useEffect(() => {
    if (open) {
      setFormValues({ nurses: [], message_text: '' }); // Clear form values when dialog opens
    }
  }, [open]);

  const handleSend = async () => {
    setLoading(true); // Set loading to true
    await ApiRequest({
      url: '/messages/sendMultiple',
      method: 'POST',
      body: { ...formValues },
      setResponse: (response: any) => {
        setLoading(false); // Set loading to false
        if (response.status === 'success') {
          loadList();
          onClose();
        }
      }
    });
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Enviar Nuevo Mensaje</DialogTitle>
      <DialogContent>
        <AutocompleteField
          label="Enfermeras"
          endpoint="/nurses/list"
          multiple={true}
          value={formValues.nurses}
          onChange={(data: any) => setFormValues({ ...formValues, nurses: data || [] })}
        />
        <TextField
          label="Mensaje"
          multiline
          rows={3}
          fullWidth
          margin="normal"
          value={formValues.message_text}
          onChange={(e) => setFormValues({ ...formValues, message_text: e.target.value })}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <LoadingButton 
          variant="contained" 
          onClick={handleSend} 
          loading={loading} // Set loading state
        >
          Enviar
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}